import { Grid } from "@mui/material"
import { useEffect } from "react"
import { FormContainer, AutocompleteElement } from "react-hook-form-mui"
import { useWatch, useForm } from "react-hook-form"
import { Type } from "@/modules/adv2/components/formFields/typeSelect"
import { useGetBotsByTypeQuery } from "../store"

interface BotSelectorProps {
  onBotSelect: (botUsername: string | null) => void
}

interface FormData {
  type_id?: number
  bot_id?: number
}

export const BotSelector: React.FC<BotSelectorProps> = ({ onBotSelect }) => {
  const formContext = useForm<FormData>({
    defaultValues: {
      type_id: undefined,
      bot_id: undefined,
    },
  })

  const typeId = useWatch({ control: formContext.control, name: "type_id" })
  const botId = useWatch({ control: formContext.control, name: "bot_id" })

  const { data: bots, isFetching: isLoadingBots } = useGetBotsByTypeQuery(
    { pathParams: { type_id: typeId! } },
    { skip: !typeId },
  )

  // Сбросить выбранного бота при изменении типа
  useEffect(() => {
    if (typeId) {
      formContext.setValue("bot_id", undefined)
      onBotSelect(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeId])

  // Передать username бота родителю при выборе
  useEffect(() => {
    if (botId && bots) {
      const selectedBot = bots.find((bot) => bot.id === botId)
      if (selectedBot) {
        onBotSelect(selectedBot.name) // name содержит username
      }
    } else {
      onBotSelect(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botId, bots])

  return (
    <FormContainer formContext={formContext}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Type<FormData> required name="type_id" for="bots" label="Тип бота" />
        </Grid>
        <Grid item xs={12} md={6}>
          <AutocompleteElement<FormData>
            name="bot_id"
            label="Бот"
            loading={isLoadingBots}
            matchId
            required
            autocompleteProps={{
              disabled: !typeId || isLoadingBots,
              fullWidth: true,
              filterOptions: (
                options: any[],
                { inputValue }: { inputValue: string },
              ) => {
                const normalized = inputValue
                  .replace(/^@+/, "")
                  .trim()
                  .toLowerCase()
                if (!normalized) return options
                return options.filter((option: any) =>
                  (option?.name ?? "").toLowerCase().includes(normalized),
                )
              },
              getOptionLabel: (option: any) => option?.name || "",
              renderOption: (props: any, option: any) => (
                <li {...props} key={option.id}>
                  <span style={{ flexGrow: 1 }}>{option.name}</span>
                  <span
                    style={{
                      fontSize: "0.75rem",
                      color: "text.secondary",
                      marginLeft: 8,
                      whiteSpace: "nowrap",
                    }}
                  >
                    💬 {option.total_chats ?? 0} &nbsp; ✉️{" "}
                    {option.total_messages ?? 0}
                  </span>
                </li>
              ),
            }}
            options={bots ?? []}
          />
        </Grid>
      </Grid>
    </FormContainer>
  )
}
